export default __webpack_public_path__ + "static/media/Vogel-mit-Ast.b2d682be.png";